import type { ReportExportFilterCondition } from '@ulysses-inc/harami_api_client'
import { addDays, format } from 'date-fns'

export type ReexportDefaults = {
  templateIds: number[]
  placeNodeUuids: string[]
  startDate: string | undefined
  endDate: string | undefined
}

/**
 * 「再出力」で渡された過去の出力条件をフォーム初期値に変換する。
 *
 * - 単一出力は templateId、一括出力は templateIds を templateIds[] に揃える。
 * - 一括出力(複数ひな形)は送信時に全現場へ自動展開されるため、現場は引き継がず空にする。
 *   単一出力のみ現場を引き継ぐ。
 * - endDate は送信時に +1 日して保存される(排他的終端)ため、表示用に -1 日戻す。
 *   startDate はそのまま。
 */
export const buildReexportDefaults = (
  filterCondition: ReportExportFilterCondition | undefined,
): ReexportDefaults | undefined => {
  if (!filterCondition) return undefined

  const templateIds =
    filterCondition.templateIds ??
    (filterCondition.templateId != null ? [filterCondition.templateId] : [])
  const isBulk = templateIds.length > 1

  return {
    templateIds,
    placeNodeUuids: isBulk ? [] : (filterCondition.placeNodeUuidList ?? []),
    startDate: filterCondition.startDateTime
      ? format(filterCondition.startDateTime, 'yyyy-MM-dd')
      : undefined,
    endDate: filterCondition.endDateTime
      ? format(addDays(filterCondition.endDateTime, -1), 'yyyy-MM-dd')
      : undefined,
  }
}
